import { Injectable } from '@angular/core';
import moment from 'moment/moment';

@Injectable({
  providedIn: 'root'
})

export class ValidationService {
  regexp = {
    mobilenumberHu: {}
  };

  constructor( ) {}

  updateRegex() {
    //regexp for hunagrian phone numbers
    //updated on 2019. May 28. based on http://agapub.nmhh.hu/aga_web/szolgaltatoBeforeAction?request_locale=hu info
    //valid mobile prefixes are: 20 30, 31, 50, 70
    //valid numbers for prefix 20 are: 2000000 to 2022999 and 2025000 to 2027999 and 2030000 to 9999999 (TELENOR)
    //valid numbers for prefix 30 are: 1500000 to 1579999 and 1600000 to 9999999 (TELECOM)
    //valid number for prefix 31 are between: 7700000 to 7719999 and 7800000 to 7909999 (UPC)
    //valid number for prefix 31 are between: 3100000 to 3197999 and 3199000 to 3329999 and 3666000 to 3666999 (VODAFONE)
    //valid numbers for prefix 50 are: 1000000 to 1199999 (DIGI)
    //valid numbers for prefix 70 are: 1188000 to 1188999 and 1940000 to 1940999 and 1975000  to 9999999 (VODAFONE)
    this.regexp.mobilenumberHu = {
        "2000000 to 2019999 | 20 Telenor": /^(\+362020[01][0-9]{4})$/,
        "2020000 to 2022999 | 20 Telenor": /^(\+3620202[0-2][0-9]{3})$/,
        "2025000 to 2027999 | 20 Telenor": /^(\+3620202[5-7][0-9]{3})$/,
        "2030000 to 2099999 | 20 Telenor": /^(\+362020[3-9][0-9]{4})$/,
        "2100000 to 2999999 | 20 Telenor": /^(\+36202[1-9][0-9]{5})$/,
        "3000000 to 9999999 | 20 Telenor": /^(\+3620[3-9][0-9]{6})$/,

//        "1500000 to 1579999 | 30 Telecom": /^(\+363015[0-7][0-9]{4})$/,
//        "1600000 to 1999999 | 30 Telecom": /^(\+36301[6-9][0-9]{5})$/,
        "0000000 to 9999999 | 30 Telecom": /^(\+3630[0-9]{7})$/,

        "7700000 to 7719999 | 31 UPC": /^(\+363177[0-1][0-9]{4})$/,
        "7800000 to 7899999 | 31 UPC": /^(\+363178[0-9]{5})$/,
        "7900000 to 7909999 | 31 UPC": /^(\+3631790[0-9]{4})$/,

        "3100000 to 3189999 | 31 Vodafone": /^(\+363131[0-8][0-9]{4})$/,
        "3190000 to 3197999 | 31 Vodafone": /^(\+3631319[0-7][0-9]{3})$/,

        "1000000 to 1199999 | 50 Digi": /^(\+36501[01][0-9]{5})$/,

        "1188000 to 1188999 | 70 Vodafone": /^(\+36701188[0-9]{3})$/,
        "1940000 to 1940999 | 70 Vodafone": /^(\+36701940[0-9]{3})$/,
        "1975000 to 1979999 | 70 Vodafone": /^(\+3670197[5-9][0-9]{3})$/,
        "1980000 to 1999999 | 70 Vodafone": /^(\+367019[8-9][0-9]{4})$/,
        "2000000 to 9999999 | 70 Vodafone": /^(\+3670[2-9][0-9]{6})$/
    };
  }

  //filtering hungarian phone numbers
  filterphoneHu(phone: string) {
    var regexpFilter = /^(06|0036)/g;
    var replaceValue = "+36";
    return phone + "" === phone
      ? phone.replace(regexpFilter, replaceValue)
      : phone;
  };

  //checking hungarian mobile phone numbers
  mobileValidator(phonenumber: string) {
    var filteredPhone = this.filterphoneHu(phonenumber);
    var result = false;
    for (var key in this.regexp.mobilenumberHu) {
      if (Object.prototype.hasOwnProperty.call(this.regexp.mobilenumberHu, key)) {
        //if (regexp.mobilenumberHu.hasOwnProperty(key)) {
        result = this.regexp.mobilenumberHu[key].test(filteredPhone);
        if (result === true) {
          break;
        }
      }
    }
    return result;
  };

  //checking email
  emailValidator(input: string) {
    if (input == null || input === '') {
      return null;
    } else {
      const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // const emailRegexMinimal = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
      // const emailRegexRFC5322 = (?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])

      return emailRegex.test(input) ? true : false;
    }
  }

  //checking passport number
  passportNumberValidator(input: string) {
    if(input.length > 0) {
      return true
    } else {
      return false
    }
  }

  //checking tax number
  taxNumberValidator(input: string, birthDate: string) {
    const value = input;
    const taxNumber = value ? value.toString() : '';

    // let valid = true;
    if (taxNumber == null || taxNumber === '') { // Az üres szöveget nem ellenőrizzük, ezért valid
      return true; // valid = true;
    } else {
      if (taxNumber.length !== 10) {
        return false; // valid = false;
      } else {
        let taxNumberSum = 0;
        for (let i = 1; i < 10; i++) {
          taxNumberSum += i * parseInt(taxNumber[i - 1]);
        }
        const remain = taxNumberSum % 11;

        if (parseInt(taxNumber[9]) !== remain && parseInt(taxNumber[9]) !== (11 - remain)) {
          return false; // valid = false;
        } else {
          // Formátum ellenőrzés
          if (taxNumber[0] !== '8') {
            return false;
          } else {
            if (birthDate == null || birthDate === '') { // Az üres dátummal nem vetjük össze, ezért valid
              return true; // valid = true;
            } else {
              const diff = Math.abs(moment('1867-01-01').diff(moment(birthDate), 'days')).toString();
              if (diff !== taxNumber.substring(1, 6)) {
                return false;
              } else {
                return true;
              }
            }
          }
        }
      }
    }
  }

  socsecNumberValidator(input: string) {
    let socialSecurityNumber = input ? input.toString() : '';
    socialSecurityNumber = socialSecurityNumber.replace(/[^a-zA-Z0-9]/g, '');
    if (socialSecurityNumber == null || socialSecurityNumber === '') { // Az üres szöveget nem ellenőrizzük, ezért valid
      return true; // valid
    } else {
      if (socialSecurityNumber.length !== 9) {
        return false; // valid = false;
      } else {
        let sum = 0;

        for (let i = 1; i < 9; i++) {
          const multiplier = i % 2 === 0 ? 7 : 3;
          sum += multiplier * parseInt(socialSecurityNumber[i - 1]);
        }

        const remain = sum % 10;

        if (parseInt(socialSecurityNumber[8]) !== remain) {
          return false; // valid = false;
        } else {
          return true; // valid
        }
      }
    }
  }
}
